/* Action Types */
export const SEND_RESELLER_TYPE_FAIL = 'la/ui/resellerType/FAIL';
export const SEND_RESELLER_TYPE_REQUEST = 'la/ui/resellerType/REQUEST';
export const SEND_RESELLER_TYPE_SUCCESS = 'la/ui/resellerType/SUCCESS';

export const LOAD_RESELLER_TYPE_FAIL = 'la/ui/resellerType/LOAD_FAIL';
export const LOAD_RESELLER_TYPE_REQUEST = 'la/ui/resellerType/LOAD_REQUEST';
export const LOAD_RESELLER_TYPE_SUCCESS = 'la/ui/resellerType/LOAD_SUCCESS';
